import { NotificationInstance } from 'antd/es/notification/interface'
import { atom } from 'recoil'

const notificationApiAtom = atom<NotificationInstance | null>({
  key: 'notificationApiAtom',
  default: null
})

export default notificationApiAtom
